module.exports = __webpack_public_path__ + "static/media/download-googleplay-ic.3fc99926.svg";